<template>
  <span class="c-header__slot">
    <div
      data-testid="button-bar-navigation-menu"
      @click="toggleCategoryMenu(true)"
    >
      <vIcon
        name="hamburguer"
        color="primary"
      />
    </div>

    <vHeaderMenu
      :should-show-menu="shouldShowCategoryMenu"
      :should-schedule-menu-hide="false"
      position="left"
      @close-menu="toggleCategoryMenu(false)"
    >
      <vCategoryMenu
        :tree="categoryTree"
      />
    </vHeaderMenu>
  </span>
</template>

<script>
  import vIcon from '@/web/components/icon.vue'
  import vHeaderMenu from '@/web/components/header/menu.vue'
  import vCategoryMenu from '@/web/components/header/responsive-category-menu/category-menu.vue'

  export default {
    components: {
      vHeaderMenu,
      vCategoryMenu,
      vIcon
    },
    props: {
      categoryTree: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        shouldShowCategoryMenu: false
      }
    },
    methods: {
      toggleCategoryMenu(visibility) {
        this.shouldShowCategoryMenu = visibility
      }
    }
  }
</script>
